
import { instantiate } from './Telugumatchmakers-composeApp.uninstantiated.mjs';


const exports = (await instantiate({
})).exports;

export const {
onNativeBackPressed,
hasBackHandler,
memory,
_initialize
} = exports


